/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import useStyles from '../FOTableHeadStyle';
import Tooltip from '../../../common/Tooltip';
import CustomHelpIcon from '../../../common/CustomHelpIcon';

const FOHeadCellToolTip = ({ tooltipContent, tooltipAria }) => {
  const classes = useStyles();
  return (
    <Tooltip data-testid="tooltip-test" title={tooltipContent} customAria={tooltipAria} wide>
      <span role="button" tabIndex="0" onClick={e => e.stopPropagation()} className={classes.iconColorContainer}>
        <CustomHelpIcon />
      </span>
    </Tooltip>
  );
};

export default FOHeadCellToolTip;
